import {computed, makeObservable} from 'mobx';

import {IMCAttachment} from '../../api/proto';
import {randomUint8Array, uint8ArrayToUuid} from '../../utils/arrayUtils';
import Message from '../Message';
import Attachment from './Attachment';
import {IAttachmentProgress} from './AttachmentProgress';

export class MessageAttachment extends Attachment {
  constructor(public raw: IMCAttachment, public message: Message) {
    super(raw);
    makeObservable(this);
  }

  @computed get unicID(): string {
    if (!this.id) {
      return uint8ArrayToUuid(randomUint8Array());
    }

    return `${this.id}_${this.message.id.toString()}`;
  }

  @computed get messagePreview(): MessageAttachment | null | undefined {
    if (!this.preview) {
      return null;
    }

    return new MessageAttachment(this.preview, this.message);
  }

  @computed get progress(): IAttachmentProgress | null | undefined {
    const uploadState = this.message.chat.store.channel.app.uploader.progressMap[this.uuid];
    const downloadState = this.message.chat.store.channel.workspace.attachmentStore.progressMap[this.uuid];

    return uploadState || downloadState;
  }
}

export default MessageAttachment;
